import React, { useEffect, useState, useRef } from "react";
import "./Alert.scss";
import check from "../../assets/alertImg/check.png";
import info from "../../assets/alertImg/info.png";
import warning from "../../assets/alertImg/warning.png";
import danger from "../../assets/alertImg/x.png";

const Alert = ({ arrayAlertsModule, setArrayAlertsModule, isVisibleModule, setIsVisibleModule }) => {
    const [animationOpen, setAnimationOpen] = useState("");
    const timeoutsRef = useRef({}); // Guarda los timeouts por ID

    const handleIcon = (type) => {
        switch (type) {
            case "success": return check;
            case "info": return info;
            case "warning": return warning;
            case "danger": return danger;
            default: return info;
        }
    };

    // Detectar alertas nuevas y crear sus timeouts
    useEffect(() => {
        if (isVisibleModule) {
            setAnimationOpen("is-open");

            arrayAlertsModule.forEach(alert => {
                // Solo crear timeout si aún no existe para ese ID
                if (!timeoutsRef.current[alert.id]) {
                    const timeoutId = setTimeout(() => {
                        handleCloseAlert(null, alert.id); // autocierre
                    }, 5000);
                    timeoutsRef.current[alert.id] = timeoutId;
                }
            });
        }

        return () => {
            // Limpieza si el componente se desmonta
            Object.values(timeoutsRef.current).forEach(clearTimeout);
            timeoutsRef.current = {};
        };
    }, [arrayAlertsModule, isVisibleModule]);

    const handleCloseAlert = (e, id) => {
        if (e) e.preventDefault();

        // Limpiar timeout asociado
        if (timeoutsRef.current[id]) {
            clearTimeout(timeoutsRef.current[id]);
            delete timeoutsRef.current[id];
        }

        const updated = arrayAlertsModule.filter(alert => alert.id !== id);
        setArrayAlertsModule(updated);
        setIsVisibleModule(updated.length > 0);
    };

    return (
        <>
            {isVisibleModule &&
                arrayAlertsModule.map((alert) => (
                    <div key={alert.id} className={"alert " + animationOpen}>
                        <div className={"alertbox " + alert.type}>
                            <div className="icon"><img src={handleIcon(alert.type)} alt="icono" /></div>
                            <div className="message"><h2>{alert.message}</h2></div>
                            <div className="closeButton" onClick={(e) => handleCloseAlert(e, alert.id)}>
                                <button>X</button>
                            </div>
                        </div>
                    </div>
                ))
            }
        </>
    );
};

export default Alert;
